var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 0H.99A.99.99 0 0 0 0 .99v16.02a.99.99 0 0 0 .99.99h8.622v-6.975h-2.34v-2.7h2.34V6.3a3.276 3.276 0 0 1 3.492-3.6c.7-.004 1.4.032 2.097.108v2.43H13.77c-1.134 0-1.35.54-1.35 1.323v1.737h2.7l-.351 2.7H12.42V18h4.59a.99.99 0 0 0 .99-.99V.99a.99.99 0 0 0-.99-.99Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;